export default "__VITE_ASSET__BHazst35__"